import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import EmployeeLog from "./EmployeeLog";

const EmployeeLogPage = () => {
  return (
    <NavHeightAdjust>
      <EmployeeLog />
    </NavHeightAdjust>
  );
};

export default EmployeeLogPage;
